module.exports = __webpack_public_path__ + "static/media/mobile.4e72ba31.png";